import { defineRoutes } from '#utils';

export const routes = defineRoutes(
  {
    cesGroups: {
      create: '/ces-groups',
      find: '/ces-groups',
      get: (id: string) => `/ces-groups/${id}`,
      members: {
        create: (id: string) => `/ces-groups/${id}/members`,
        remove: (id: string, personnelId: string) => `/ces-groups/${id}/members/${personnelId}`,
      },
      patch: (id: string) => `/ces-groups/${id}`,
      remove: (id: string) => `/ces-groups/${id}`,
    },
  },
  { exactKeys: ['cesGroups'] },
);
